// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SectionContract = contract({
  name: "Section",
  description: "THE page scaffold. A page is an ordered stack of Sections — every distinct band (hero, logos, features, pricing, testimonial, CTA, footer) gets its OWN Section so each is independently themeable. `Section` is the full-width band (scope + vertical rhythm). **REQUIRED scaffold: a `Section` ALWAYS contains a `Container`.** Put content inside the `Container`, never directly in the `Section`. For an edge-to-edge band use `<Container maxW=\"full\">` — that is how you go full-bleed; you never omit the Container. NEVER hand-roll `<section className=\"py-20\">` or a `<div className=\"max-w-7xl mx-auto px-6\">` wrapper — that is exactly what `Section` + `Container` replace. This holds for app content regions too, not just marketing pages (AppShell is only the outer chrome; the regions inside it are still `Section` → `Container`). The content inside the Container is free — use the parts (SectionEyebrow/Title/Subtitle/Description/Actions/Media) for the common heading+copy+CTA+media shape, or drop any JSX. SectionMedia is a slot for any media (MediaSurface image, Carousel, VideoPlayer, embed, or a whole app UI).",
  import: "@gradeui/ui",
  aliases: ["section","band","hero section","page section","content section","marketing section","landing section","full bleed","container","max width wrapper","page band","section block"],
  subcomponents: ["Container","SectionEyebrow","SectionTitle","SectionSubtitle","SectionDescription","SectionActions","SectionMedia"],
  composesWith: ["Container","MediaSurface","Carousel","VideoPlayer","Button","Badge","Card","Grid","Stack"],
  styleDefaults: {"Section":"w-full py-16 md:py-24","Container":"mx-auto w-full px-4 md:px-6 lg:px-8 max-w-7xl","SectionEyebrow":"inline-block text-xs font-medium uppercase tracking-wider text-muted-foreground","SectionTitle":"text-balance text-3xl font-semibold tracking-tight md:text-4xl","SectionSubtitle":"text-lg text-muted-foreground md:text-xl","SectionDescription":"leading-relaxed text-muted-foreground","SectionActions":"flex flex-wrap items-center gap-3","SectionMedia":"w-full"},
  variantDefaults: {"pad":"lg"},
  props: {
  "scope": {
      schema: z.enum(["default", "inverse", "brand", "accent", "muted", "card"]).optional(),
      design: "knob",
      description: "colour SUBTHEME; applies the `scope-*` class so the whole band re-tones (bg/fg/card/muted/border) while action colours stay vivid. Unset = the page surface. See STUDIO-COLOR.md.",
  },
  "background": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "visual band background slot: image / video / gradient / shader (drop a <BackgroundFill> here). Renders BEHIND the content; Section owns the relative/overflow/z plumbing. Works with `scope` (which re-tones the content tokens so text stays legible over the media).",
  },
  "pad": {
      schema: z.enum(["none", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      description: "vertical rhythm (responsive py); default lg. Section is ALWAYS full width — it never sets a max width.",
  },
  "as": {
      schema: z.enum(["section", "header", "footer", "div"]).optional(),
      design: "knob",
      description: "semantic element; default section.",
  },
  "maxW": {
      schema: z.enum(["sm", "md", "lg", "xl", "prose", "full"]).optional(),
      design: "knob",
      description: "centred max width + gutters; default lg. The MEASURE.",
  },
  "grid": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "snap children to a 12-column grid (use `col-span-*` on children); default false.",
  },
  },
});
